import IState from '../state';

export const welcomeScreenSeen = ({ welcomeScreen }: IState) => welcomeScreen.welcomeScreenSeen;
export const isWelcomeScreenActive = ({ app, welcomeScreen }: IState): boolean => {
  const welcomeScreenActive = app.site?.settings?.welcomeScreen?.active || false;
  return Boolean(welcomeScreenActive && !welcomeScreen.welcomeScreenSeen);
};
